import { Modal } from "react-bootstrap";

const FilterInfoModal = ({ show, closePopup, modalFilterContent }) => {
  return (
    <div>
      <Modal size="md" centered show={show} onHide={closePopup} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalFilterContent.modalHeading}
            <img className="ml-1" alt="" src={modalFilterContent.icon} />{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row m-0">
            <div className="col-12 p-0">
              <p className="modal-filter-content">{modalFilterContent.heading}</p>
              <p className="modal-filter-content-two mt-3 mb-0">{modalFilterContent.subHeading}</p>
            </div>
            <ul className="pl-3 mt-1">{!!modalFilterContent.list && !!modalFilterContent.list.length && modalFilterContent.list.map((item) => <li className="mb-1 modal-filter-content">{item}</li>)}</ul>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FilterInfoModal;
